import { render, staticRenderFns } from "./Documents.html?vue&type=template&id=1a21045e&external"
import script from "./Documents.ts?vue&type=script&lang=ts&external"
export * from "./Documents.ts?vue&type=script&lang=ts&external"
import style0 from "./Documents.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports